import ConversationActions from '../actions/conversation';
import ConversationCreatorActions from '../actions/conversation_creator';
import BrowserUtils from './browser';
import ConversationsApp from './conversations';

var paramMatch = new RegExp('(:[^/]+)');
var apiPaths = {};
var matchers;
var Router;

var routes = {
  '/conversations': function() {
    if (ConversationsApp.Store.dispatch(ConversationCreatorActions.close())) {
      ConversationsApp.Store.dispatch(ConversationActions.deselect());
    } else {
      Router.transitionTo('/conversations/new');
    }
  },
  '/conversations/new': function() {
    ConversationsApp.Store.dispatch(ConversationActions.deselect());
    ConversationsApp.Store.dispatch(ConversationCreatorActions.open());
  },
  '/conversations/:id/messages': function(path) {
    var conversationId = /\/conversations\/(.+?)\/messages/.exec(path)[1];
    var conversation = ConversationsApp.Store.getState().conversations.edges.find(function (conversation) {
      return conversation.node.id === conversationId;
    });

    if (ConversationsApp.Store.dispatch(ConversationCreatorActions.close())) {
      if (conversation) {
        ConversationsApp.Store.dispatch(ConversationActions.loadingActive(conversation.node));
        ConversationsApp.Store.dispatch(ConversationActions.fetchActive(conversation.node));
      } else {
        $('body').trigger('flashmessage', ['danger', 'Unable to load conversation']);
        Router.transitionTo('/conversations', {}, true);
        ConversationsApp.Store.dispatch(ConversationActions.deselect());
      }
    } else {
      Router.transitionTo('/conversations/new');
    }
  }
};

Router = {
  transitionTo: function(url, params, replaceRoute) {
    var replaced = url;

    for(var key in params) {
      if ({}.hasOwnProperty.call(params, key)) {
        replaced = replaced.replace(':' + key, params[key]);
      }
    }

    if (paramMatch.test(replaced)) {
      throw new Error('Missing dynamic segment parameter: ' + replaced);
    }

    if (this.location === 'history') {
      if (replaceRoute === true) {
        window.history.replaceState({ route: replaced }, null, replaced);
      } else {
        window.history.pushState({ route: replaced }, null, replaced);
      }
    }
  },
  location: 'history',
  apiPath: function(name) {
    return apiPaths[name];
  },
  __handlePopstate: function() {
    var path = BrowserUtils.pathname();
    var route;

    for(var matcher in matchers) {
      if (matchers[matcher].test(path)) {
        route = matcher;
        break;
      }
    }

    routes[route](path);
  }
};

matchers = (function buildMatchers() {
  var collector = {};
  for(var route in routes) {
    if ({}.hasOwnProperty.call(routes, route)) {
      collector[route] = new RegExp('^' + route.replace(paramMatch, '.+?') + '/?$');
    }
  }
  return collector;
}());

if (window.document && document.querySelector('.app-container.container')) {
  window.onpopstate = Router.__handlePopstate;
  apiPaths = JSON.parse(document.querySelector('.app-container.container [data-paths]').attributes.getNamedItem('data-paths').value);
}

export default Router;
